import { gql } from 'apollo-angular'

export const GET_ORGANIZATION_FILTER_ITEMS = gql`
  query getOrganizationFilterItems($resellerId: JSON!) {
    Organizations(
      where: { reseller: { equals: $resellerId } }
      limit: -1
      sort: "name"
    ) {
      docs {
        id
        name
      }
    }
  }
`
